import React from 'react';
import blackBg from '../../../images/gif/black.gif';

const Experience = () => {
    const helloHandler = () => {
        function counter(id, start, end, duration) {
            let obj = document.getElementById(id),
                current = start,
                range = end - start,
                increment = end > start ? 1 : -1,
                step = Math.abs(Math.floor(duration / range)),
                timer = setInterval(() => {
                    current += increment;
                    obj.textContent = current;
                    if (current === end) {
                        clearInterval(timer);
                    }
                }, step);
        }
        counter("count1", 780, 1000, 1000);
        counter("count2", 100, 60, 1000);
        counter("count3", 0, 150, 1000);
        counter("count4", 100, 15, 1000);
    }


    return (
        <div onMouseEnter={helloHandler}>
            <section className="py-5" style={{backgroundImage: `url(${blackBg})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: 20, color:'gold'}}>
                <div className="container">
                    <div className="row text-center">
                        <div data-aos="fade-down" data-aos-duration="1500" className="col-12">
                            <h1 className="pb-3 fw-bolder">
                                We have many years of experience in <br />
                                <span style={{ color: '#ff3465' }}>organizing events</span>
                            </h1>
                        </div>
                        <div data-aos="fade-down" data-aos-duration="3000" className="col-md-3 col-6">
                            <span id="count1" className="display-4 fw-bolder">1000</span>
                            <p>completed projects</p>
                        </div>
                        <div data-aos="fade-down" data-aos-duration="3000" className="col-md-3 col-6">
                            <span id="count2" className="display-4 fw-bolder">60</span>
                            <p>original concepts</p>
                        </div>
                        <div data-aos="fade-down" data-aos-duration="3000" className="col-md-3 col-6">
                            <span id="count3" className="display-4 fw-bolder">150</span>
                            <p>regular customers</p>
                        </div>
                        <div data-aos="fade-down" data-aos-duration="3000" className="col-md-3 col-6">
                            <span id="count4" className="display-4 fw-bolder">15</span>
                            <p>years of experience</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Experience;